/**
 * Lets tab switches warn about unsaved edits. Each screen with something
 * unsaved registers a guard under its own key (several tabs stay mounted at
 * once, so one slot would let them overwrite each other). Returns a confirm
 * message when navigation should be blocked, otherwise null.
 */

type UnsavedChangesGuard = () => string | null;

const guards = new Map<string, UnsavedChangesGuard>();

export function setUnsavedChangesGuard(next: UnsavedChangesGuard | null, key = 'configuration'): void {
  if (next) guards.set(key, next);
  else guards.delete(key);
}

/** `prefix` limits the check to guards whose key starts with it (one screen's own edits). */
export function getUnsavedChangesWarning(prefix = ''): string | null {
  for (const [key, guard] of guards) {
    if (!key.startsWith(prefix)) continue;
    try {
      const message = guard();
      if (message) return message;
    } catch {
      /* a broken guard never blocks navigation */
    }
  }
  return null;
}
